const Pagination = () => {
    return {
        pages: 0,
        borders: 10,
        borderEnd: 7,
        around: 3,

        async init () {
            await this.setPages();
            this.resize();
        },

        async setPages() {
            this.pages = Math.ceil(this.listLength / paginationSize);

            if (this.page > this.pages) {
                await this.setPage(this.pages);
            }
        },

        resize() {
            if (window.innerWidth >= 1024) {
                this.around    = 3;
                this.borders   = 10;
                this.borderEnd = 7;
            } else if (window.innerWidth >= 640) {
                this.around    = 1;
                this.borders   = 6;
                this.borderEnd = 5;
            } else {
                this.around    = 0;
                this.borders   = 4;
                this.borderEnd = 4;
            }
        },

        isVisible(element) {
            return element <= 2
                || (this.page < this.borderEnd + 1 && element < this.borders + 1)
                || (this.page > this.pages - this.borderEnd && element > this.pages - this.borders)
                || (element > this.pages - 2)
                || (this.page - this.around <= element && this.page + this.around >= element);
        },

        scrollToTop() {
            const element = document.getElementById('top');

            window.scrollTo({
                top: element ? element.getBoundingClientRect().top + window.scrollY - 80 : 0
            });
        },

        async setPage(value) {
            this.updateUrl(value);

            await this.setList();

            this.scrollToTop();
        },

        updateUrl(value) {
            this.page = value;

            const url = new URL(window.location);

            url.searchParams.set('page', value);
            window.history.replaceState({}, '', url);

            // if (typeof addBreadcrumb === 'function') {
            //     addBreadcrumb({ message: `Updating url to ${url}` });
            // }
        },
    }
}

export default Pagination;